import React, {useState, useEffect, Fragment} from 'react'
import { Container, Row, Col } from '../../../v2SPRINTA/atoms/Grid'
import css from './style.module.css'
import T from '../../../SPRINTA/translate/T'

export default (props) => {
    
    const [result, setResult] = useState(null)
    const [disqualified, setDisqualified] = useState(null)

    useEffect(() => {
        if(props.results) {
            setResult(props.results)
        }
    }, [props.results])

    useEffect(() => {
        if(props.disqualified) {
            setDisqualified(props.disqualified)
        }
    }, [props.disqualified])

    let position = 0
    
    return (
        <Container>
            <div className={css.table}>
                { result && (
                    result.map(athlete => {
                        position++
                        return (
                            <Fragment>
                                <Row className={css.tr} key={`${athlete.identifier}_${athlete.name}`}>
                                    <Col size='1' className={css.td}>
                                        {position}
                                    </Col>
                                    <Col size='8' className={css.td}>
                                        <p className={css.athleteName}>{athlete.name}</p>
                                        <p className={css.athleteTeam}>{athlete.team}</p>
                                    </Col>
                                    <Col size='3' className={css.td}>
                                        {athlete.time}
                                    </Col>
                                </Row>
                            </Fragment>   
                        )
                    })
                )}
            </div>

            <div className={css.disqualifiedTable}>
                {disqualified && (
                    <Fragment>
                        <Row className={css.tr}>            
                            <Col size='12' className={css.th}>
                                {T.txt('disqualifieds')}
                            </Col>
                        </Row>
                        {disqualified.map(athlete => {
                            return (
                                <Row className={css.tr} key={`${athlete.identifier}_${athlete.name}`}>
                                    <Col size='1' className={css.td}>
                                        -
                                    </Col>
                                    <Col size='8' className={css.td}>
                                        <p className={css.athleteName}>{athlete.name}</p>
                                        <p className={css.athleteTeam}>{athlete.team}</p>
                                    </Col>
                                    <Col size='3' className={css.td}>
                                        -
                                    </Col>
                                </Row>
                            )
                        })}
                    </Fragment>                            
                )}
            </div>            
        </Container>
    )
}



// WEBPACK FOOTER //
// ./src/components/molecules-v2/Results/index.js